export default __webpack_public_path__ + "static/media/icn-_blank.2d9a1727.svg";